import { snakeCase } from 'lodash';

export enum ResourceRequestEvents {
  ResourceRequestCreate = 'resource_request_create',
  ResourceRequestUpdate = 'resource_request_update',
  ResourceRequestDelete = 'resource_request_delete',
  ResourceRequestStatusUpdate = 'resource_request_status_update',
  ResourceRequestApprovalUpdate = 'resource_request_approval_update',
  ResourceRequestAssigneeUpdate = 'resource_request_assignee_update',
}

export const ResourceRequestEventsMap: Record<string, string> = Object.keys(
  ResourceRequestEvents,
).reduce((acc, key) => {
  acc[snakeCase(key).toUpperCase()] = ResourceRequestEvents[key];

  return acc;
}, {} as Record<string, string>);
